<template>
  <div ref="jsoneditor" />
</template>

<script>
import JSONEditor from "jsoneditor/dist/jsoneditor-minimalist.js";
import "jsoneditor/dist/jsoneditor.min.css";
import _ from "lodash";
export default {
  name: "JsonEditor",
  props: {
    json: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  watch: {
    json: {
      handler(newJson) {
        if (this.editor) {
          this.editor.set(newJson);
        }
      },
      deep: true,
    },
  },
  mounted() {
    const container = this.$refs.jsoneditor;
    const options = _.extend(
      {
        onChange: this._onChange,
      },
      this.options
    );
    this.editor = new JSONEditor(container, options);
    this.editor.set(this.json);
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  },
  methods: {
    _onChange(e) {
      if (this.editor) {
        this.$emit("change", this.editor.get());
      }
    },
  },
};
</script>